<template>

    <body>

        <main>
            <div class="container">

                <section class="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div class="container">
                        <div class="row justify-content-center">
                            <div class="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                <div class="d-flex justify-content-center py-4">
                                    <img :src="imageLogo" alt="" style="max-height: 20em;">
                                </div>

                                <div class="card mb-3">

                                    <div class="card-body">

                                        <div class="pt-4 pb-2">
                                            <h5 class="card-title text-center pb-0 fs-4">Iniciar sesión</h5>
                                            <p class="text-center small">Ingrese su usuario y contraseña para acceder al sistema</p>
                                        </div>

                                        <form class="row g-3" novalidate>

                                            <div class="col-12">
                                                <label class="form-label">Email</label>
                                                <div class="input-group has-validation">
                                                    <span class="input-group-text">@</span>
                                                    <input type="text" class="form-control" v-model="email">
                                                </div>
                                            </div>

                                            <div class="col-12">
                                                <label class="form-label">Contraseña</label>
                                                <input type="password" class="form-control" v-model="password">
                                            </div>

                                            <div class="col-12">
                                                <Atom1Loader v-if="loading" />
                                                <button v-else class="btn btn-primary w-100" @click.prevent="login">Iniciar sesión</button>
                                            </div>
                                            <div class="col-md-12 text-center">
                                                <router-link to="/ForgotPassword">
                                                    ¿Olvidó su contraseña?
                                                </router-link>
                                            </div>
                                        </form>

                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>

                </section>

            </div>
        </main><!-- End #main -->

    </body>

</template>

<script>


import useValidate from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';

import toastMixin from '@/mixins/toastMixin';
import validatorMixin from '@/mixins/validatorMixin';

import axios from "axios";

import { checkCatch } from "@/utils";

import Atom1Loader from '@/components/Utils/Loaders/Atom1Loader.vue';

export default {

    name: 'Login',

    mixins: [validatorMixin, toastMixin],

    components: { Atom1Loader },

    data() {
        return {

            v$: useValidate({ $stopPropagation: true }),

            loading: false,

            imageLogo: require('@/assets/images/logo-smart-vertical.png'),

            email: '',
            password: '',
        };
    },  

    validations() {

        return {

            email: { required, minLength: minLength(3) },
            password: { required, minLength: minLength(3) },
        };
    },  

    methods: {


        async login() {

            this.v$.$validate();

            if (this.v$.$error) {

                this.showNotification({
                    title: 'Debe ajustar los errores de validación',
                    description: '',
                    type: 'danger',
                    timeout: 4,
                });
                return;
            }

            this.loading = true;

            const data = {

                username: this.email,
                password: this.password,
            };

            await axios.post(`${this.$env.API_BASE_URL}login/`, data)
                .then((response) => {

                    const { data } = response;

                    let user = data.user;
                    user.permissions = data.permissions

                    const userSerialized = JSON.stringify(user);
                    const extraDataSerialized = JSON.stringify(data.extra_data);

                    localStorage.setItem("token", data.access_token); // Guardar el token
                    localStorage.setItem("refresh_token", data.refresh_token); // Guardar el token de renovación
                    localStorage.setItem("user", userSerialized); // Guardar el usuario
                    localStorage.setItem("extra_data", extraDataSerialized); // Guardar campos extra del usuario

                    this.$router.push("/"); // Redirigir a home

                    this.loading = false;

                    this.showNotification({
                        title: 'Éxito',
                        description: 'Sesión iniciada con éxito',
                        timeout: 4,
                    });

                }).catch((error) => {

                    this.loading = false;

                    this.showNotification({
                        title: 'Error',
                        description: 'Usuario o contraseña inválidos',
                        timeout: 4,
                        type: 'danger',
                    });

                    checkCatch(error);
                });
        },
    },
}
</script>